// extracted by mini-css-extract-plugin
module.exports = {"container":"ImagePlaceholder_container__9Bxu9","image_placeholder":"ImagePlaceholder_image_placeholder__QFYMm"};